import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Preslider from "./components/Preslider";
import Section1 from "./components/Section1";
import Section2 from "./components/Section2";
import Section3 from "./components/Section3";
import Section5 from "./components/Section5";
import Section6 from "./components/Section6";
import Section4 from "./components/Section4";
import Slidescreen from "./components/Slidescreen";
function App() {
  return (
    <>
      <Navbar />
      <Slidescreen />
      <Preslider />
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Footer />
    </>
  );
}

export default App;
